module.exports = __webpack_public_path__ + "static/media/bella_plus.b5337bcc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/bella_plus.jpeg
// module id = 272
// module chunks = 0